import { render, staticRenderFns } from "./SortPrivacy.vue?vue&type=template&id=380cb0c3&scoped=true&"
import script from "./SortPrivacy.vue?vue&type=script&lang=js&"
export * from "./SortPrivacy.vue?vue&type=script&lang=js&"
import style0 from "./SortPrivacy.vue?vue&type=style&index=0&id=380cb0c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380cb0c3",
  null
  
)

export default component.exports